export default function journeyAwareness() {
	recordPageView();
}

// determine page by examining the utag_data
const recordPageView = () => {
	if (
		window.FS &&
		window.FS.DECISION_ENGINE &&
		window.FS.propertyInfo &&
		window.FS.propertyInfo.owsCode
	) {
		const property = window.FS.propertyInfo.owsCode;
		const { aem_url } = window.utag_data;

		//chop off /content/fshr/pages/-language
		const pathParts = aem_url.split('/').slice(5);

		let section;

		if (pathParts.length) {
			if (pathParts[0] === 'properties') {
				if (pathParts.length > 2) {
					//we're on a subpage, grab the top level segment
					section = pathParts[2];
				} else {
					//we're on a landing page
					section = 'landing';
				}
			} else {
				//not under properties, so this is the segment we want for global
				section = pathParts[0];
			}
		} else {
			//this is the global homepage
			section = 'landing';
		}

		window.FS.DECISION_ENGINE.recordView({ property, section });
	}
};
